import "./PublicImpact.module.css";
import Navigation from "@/reusable_sections/Header";
import Infrastructure from "./sections/Infrastructure";
import Gallery from "./sections/Gallery";
import Milestones from "./sections/Milestones";
import Footer from "@/reusable_sections/Footer";
export default function PublicImpactPage() {
  return <div>
      <Navigation />
      <Infrastructure />
      <Gallery />
      <Milestones />
      <Footer />
    </div>;
}